import { EventEmitter, Injectable } from '@angular/core';
import { RatingRequest } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class RatingCommunicationService {
  onValueChange: EventEmitter<RatingRequest> = new EventEmitter<RatingRequest>();

  constructor() { }
}
